import { useMemo } from 'react';

import type { AvtalegiroAgreementDetails } from '../../../../generated-types';
import { useFormContext } from '../../../../hooks/useForm';
import { AvtaleGiroAction, AvtaleGiroActionType } from './actions';
import { AvtaleGiroState } from './state';
import { AvtaleGiroError } from './validate';

export default (avtalegiro: AvtalegiroAgreementDetails) => {
    const { state } = useFormContext<AvtaleGiroState, AvtaleGiroAction, AvtaleGiroError, AvtaleGiroActionType>();
    return useMemo(
        () =>
            avtalegiro.toAccount.value !== state.toAccount?.accountNumber.value ||
            avtalegiro.fromAccountNumber.value !== state.fromAccount?.value ||
            avtalegiro.kid.value !== state.kid?.value ||
            avtalegiro.limits.transaction !== state.transactionLimit ||
            (avtalegiro.limits?.monthly ?? 0) !== state.monthlyLimit ||
            avtalegiro.ownText !== state.note,
        [avtalegiro, state],
    );
};
